<template>
  <BaseLayout>
    <v-container fluid>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8 lg6>
          <SessionForm
            v-model="session"
            @submit="save"
            :backLink="{ name: 'sessions' }"
            title="Session erstellen"
            submitText="Erstellen"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </BaseLayout>
</template>

<script>
import Session from '@/models/session';
import Business from '@/models/business';

export default {
  name: 'NewSession',
  requireSuperuser: true,
  async initialAsyncData() {
    await Business.fetchAll();
  },
  data() {
    return {
      session: new Session(),
    };
  },
  methods: {
    async save() {
      await this.session.save();
      this.$showSnackbar({ text: 'Geschäft erfolgreich erstellt.', color: 'success' });
      this.$router.push({ name: 'sessions' });
    },
  },
};
</script>
